module.exports = __webpack_public_path__ + "static/media/CNX100.8cbad1bf.txt";